import { FC } from 'react'

const ArrowStepIndicatorLightDark: FC<{ width?: string; height?: string }> = ({
  width,
  height,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 42 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M41 59.5L1 1V117L41 59.5Z" fill="white" />
      <path d="M41 1H1L41 59V1Z" fill="#F3F4F6" />
      <path d="M41 117H1L41 59V117Z" fill="#F3F4F6" />
      <path d="M1 1L41 59L1 117" stroke="#D1D5DB" />
    </svg>
  )
}
export default ArrowStepIndicatorLightDark
